import { subDays } from 'date-fns';
import { useSelector } from 'react-redux';
import { CustomProvider, DateRangePicker } from 'rsuite';
import { RangeType } from 'rsuite/esm/DatePicker';
import { DateRange } from 'rsuite/esm/DateRangePicker';

import { IRootState } from '../../Storage/Redux/store';

import {
    addMonths,
    endOfMonth,
    endOfWeek,
    startOfMonth,
    startOfWeek
} from 'date-fns';
import DateRangePickerProps, { PredefinedRangeKey } from '../../Interfaces/Props/DateRangePickerProps';

const buildRanges = (
    rangeKeys: PredefinedRangeKey[] = []
): RangeType<DateRange>[] => {
    const now = new Date();

    const map: Record<PredefinedRangeKey, RangeType<DateRange>> = {
        ThisWeek: {
            label: 'This week',
            value: [startOfWeek(now), endOfWeek(now)]
        },
        Last7Days: {
            label: 'Last 7 days',
            value: [subDays(now, 6), now]
        },
        Last30Days: {
            label: 'Last 30 days',
            value: [subDays(now, 29), now]
        },
        ThisMonth: {
            label: 'This month',
            value: [startOfMonth(now), endOfMonth(now)]
        },
        LastMonth: {
            label: 'Last month',
            value: [startOfMonth(addMonths(now, -1)), endOfMonth(addMonths(now, -1))]
        },
        ThisYear: {
            label: 'This year',
            value: [new Date(now.getFullYear(), 0, 1), now]
        },
        LastYear: {
            label: 'Last year',
            value: [
                new Date(now.getFullYear() - 1, 0, 1),
                new Date(now.getFullYear(), 0, 0)
            ]
        },
        AllTime: {
            label: 'All time',
            value: [new Date(now.getFullYear() - 1, 0, 1), now]
        },
        Clear: {
            label: 'Clear',
            value: null
        }
    };

    const keys = new Set(rangeKeys)
    return Array.from(keys).map(key => map[key]);
};



const DateRangerPicker = (props: DateRangePickerProps) => {
    const theme = useSelector((state: IRootState) => state.themeConfig.isDarkMode)
        ? 'dark'
        : 'light';

    const format = props.format ?? 'dd-MM-yyyy';

    const dynamicRanges = props.autoComplete ? buildRanges(props.autoComplete) : [];

    return (
        <div className={props.className} style={props.style}>
            <label>{props.label}</label>
            <CustomProvider theme={theme}>
                <DateRangePicker
                    name={props.name}
                    ranges={dynamicRanges}
                    value={props.value}
                    format={format}
                    size={props.size}
                    disabled={props.disable}
                    onOk={props.onSave}
                    cleanable={props.clearable ?? false}
                    onChange={(value, e) => {
                        if (props.onChange) {
                            props.onChange(value, e);
                        }
                        if (value) props.onSave(value as [Date, Date]);
                    }}
                    showMeridiem={props.showMeridiem}
                    placeholder={props.placeholder}
                    preventOverflow={props.preventOverflow}
                />
            </CustomProvider>
        </div>
    );
};


export default DateRangerPicker